import { useState } from "react";
import { api, type Me } from "../api.js";

export function SignIn({
  onSignedIn,
  onShowGuide,
}: {
  onSignedIn: (me: Me) => void;
  /** FR-HELP-1 — the guide needs no account, so it is offered before one. */
  onShowGuide?: () => void;
}): React.JSX.Element {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <main className="centre">
      <form
        className="card stack"
        onSubmit={(event) => {
          event.preventDefault();
          setBusy(true);
          setError(null);
          api
            .login(username, password)
            .then(onSignedIn)
            .catch((e: unknown) => setError(e instanceof Error ? e.message : "Sign in failed."))
            .finally(() => setBusy(false));
        }}
      >
        <h1>Core Baddy</h1>

        <label>
          Username
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            required
          />
        </label>

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error ? <p className="error">{error}</p> : null}

        <button className="primary" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <p className="muted small">
          Can&apos;t get in? The <a href="/backup/">session tracker</a> works without an account.
        </p>

        {onShowGuide ? (
          <p className="muted small">
            New here?{" "}
            <button type="button" className="linkish" onClick={onShowGuide}>
              How this works
            </button>{" "}
            — two minutes, no account needed.
          </p>
        ) : null}
      </form>
    </main>
  );
}
